import React, { InputHTMLAttributes } from 'react';
import { EMPTY_OPTION } from 'commons';
import * as S from './styles';
import { useSelect } from '../../hooks';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  allowPasteList?: boolean;
}

export function Input({ allowPasteList = false, ...rest }: Props) {
  const {
    selectInputRef,
    searchable,
    option,
    setOption,
    inputText,
    setInputText,
    tagList,
    setTagList,
  } = useSelect();

  return (
    <S.Input
      ref={selectInputRef}
      readOnly={!searchable}
      value={option.label !== '' ? option.label : inputText}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target;

        if (allowPasteList && value && value.includes(',')) {
          const pastedCodes = value
            .split(',')
            .filter((text) => text.length > 0)
            .map((text: string) => {
              const code = text.trim().toUpperCase();

              return {
                label: code,
                value: code,
              };
            })
            .filter((newTag) => {
              return !tagList.some((tag) => tag.value === newTag.value);
            });

          setTagList((cur) => [...cur, ...pastedCodes]);
          event.target.value = '';
          setInputText('');
        } else {
          setInputText(value);
        }

        if (Boolean(option.label)) {
          setOption(EMPTY_OPTION);
        }
      }}
      onKeyDown={(event: React.KeyboardEvent) => {
        if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
          event.preventDefault();
        }
      }}
      tabIndex={-1}
      autoComplete="off"
      {...rest}
    />
  );
}
